import React from "react";
import { useNavigate } from 'react-router-dom';
import './Main.css';
import BrunoProgress from "../Assets/Bruno_the_fox_buterfly_assets/Bruno_Progress.jpg"
import BrunoCover from "../Assets/Bruno_the_fox_buterfly_assets/Bruno_eBook_cover_English.jpeg"
import BrunoChars from "../Assets/Bruno_the_fox_buterfly_assets/Bruno_chars.jpeg"
import BrunoStoryboard from "../Assets/Bruno_the_fox_buterfly_assets/Bruno_storyboards.jpeg"
import BenTurtleSketches from "../Assets/Ben_the_turtle/ben_the_turtle.jpg";
import BenTurtleCover from "../Assets/Ben_the_turtle/Cover_Ben_the_Turtle.jpg";
import BenTurtlePractice from "../Assets/Ben_the_turtle/Practice_sketch_for_book_lower_res.jpg";
import BenTurtleTop from "../Assets/Ben_the_turtle/sketch_from_top_ben_the_turtle.jpg";

const ChildrenBook = () => {
    const navigate = useNavigate();

    return (
        <div className="subscreen-container">
            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '2rem' }}>
                <button onClick={() => navigate('/')} className="back-button">←</button>
                <h1 style={{ margin: 0 }}>Children's Books</h1>
            </div>
            <p>I write children's books. So far I have written 3 books, and fully published one of them. I am always happy to collaborate with parents, education and children professionals, illustrators, editors, and publishers. <a href="mailto:bakurov.illya@gmail.com">Contact me</a></p>
            
            <h2>Bruno the Fox and the Butterfly</h2>
            <div className="links-list">
                <a href="https://a.co/d/jgxfAGg">(🇬🇧) Bruno the Fox and the Butterfly</a>
                <a href="https://a.co/d/7GvYbWl">(🇺🇦) Лисеня Бруно і Метелик</a>
            </div>
            <div className="image-gallery">
                <div className="image-gallery-item">
                    <img src={BrunoChars} alt="Early Character Designs"></img>
                    <p>Early Character Designs</p>
                </div>
                <div className="image-gallery-item">
                    <img src={BrunoStoryboard} alt="Early Storyboards"></img>
                    <p>Early Storyboards</p>
                </div>
                <div className="image-gallery-item">
                    <img src={BrunoProgress} alt="Choosing the cover design"></img>
                    <p>Choosing the cover design</p>
                </div>
                <div className="image-gallery-item">
                    <img src={BrunoCover} alt="Final Design for English version"></img>
                    <p>Final Design for English version</p>
                </div>
            </div>

            <h2 style={{ marginTop: '2.5rem' }}>Ben the Turtle and a Gift for His Teacher</h2>
            <p>
                This was the very first children's book I created. I couldn't finish working on it with the illustrator, so it's still a dream of mine to publish it one day. The story is written and ready, read it <a href="/ben-the-turtle-story">here</a> and I'm always open to collaborating with illustrators or publishers who'd like to help bring Ben's adventure to life!
            </p>
            <a
                href="/ben-the-turtle-story"
                className="links-list"
                style={{ marginTop: '1.5rem', display: 'inline-block' }}
                onClick={e => { e.preventDefault(); navigate('/ben-the-turtle-story'); }}
            >
                Read the Story &rarr;
            </a>
            <div className="image-gallery">
                <div className="image-gallery-item">
                    <img src={BenTurtleSketches} alt="Ben the Sea Turtle Sketches" />
                    <p>Ben the Sea Turtle - Character Sketches</p>
                </div>
                <div className="image-gallery-item">
                    <img src={BenTurtleCover} alt="Ben the Turtle Cover" />
                    <p>Book Cover Concept</p>
                </div>
                <div className="image-gallery-item">
                    <img src={BenTurtlePractice} alt="Practice Sketch for Book" />
                    <p>Practice Sketch for Book</p>
                </div>
                <div className="image-gallery-item">
                    <img src={BenTurtleTop} alt="Sketch from Top - Ben the Turtle" />
                    <p>Sketch from Top</p>
                </div>
            </div>
        </div>
    )
}

export default ChildrenBook; 